export class PermissionIntermediateEntity {
  corpId: number;
  id: number;
  permissionId: number;
  permissionRoleId: number;
}


